import * as React from 'react';
import { Head } from '@inertiajs/react';

interface SEOBlockProps {
  appUrl: string;
}

export function SEOBlock({ appUrl }: SEOBlockProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Abasto Virtual',
    description: 'Ecommerce nativo de frutas y verduras en Córdoba. Stock en tiempo real, seguimiento de pedidos, búsqueda inteligente y atención personalizada.',
    url: `${appUrl}/por-que-elegirnos`,
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="whyus-seo">
        <style>{`
          .whyus-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .whyus-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .whyus-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .whyus-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="whyus-seo-inner">
          <h2>Ecommerce de frutas y verduras en Córdoba</h2>
          <p>
            Abasto Virtual es un ecommerce nativo de frutas y verduras en Córdoba.
            Comprá online con stock en tiempo real, seguimiento de pedidos, historial
            completo de compras y atención personalizada. Delivery programado en Córdoba.
          </p>
        </div>
      </section>
    </>
  );
}
